export const loadingConstants = {
  SHOW: 'LOADING_SUCCESS',
  HIDE: 'LOADING_HIDE',
} as const;
